module.exports = __webpack_public_path__ + "img/aboutus_banner.ee1e294e.png";